<template>
  <div class="entering-wrapper">
    <entering-step :step="step" stepOneText="个人信息" stepTwoText="线下首诊信息" />
    <edit-first-record :private-id="privateId" :doc-id="docId" @success="success"></edit-first-record>
  </div>
</template>

<style lang="less" scoped>
  .entering-wrapper{
    background: #F7F7F7;
  }
</style>

<script type="text/javascript">
  import enteringStep from '@/components/Common/enteringStep'
  import editFirstRecord from '@/components/Common/firstRecordEdit'
  export default {
    data() {
      return {
        step: 2,
        privateId: this.$route.query.private_id,
        docId: this.$route.query.doc_id,
      }
    },
    components: {
      enteringStep,
      editFirstRecord
    },
    methods: {
      success() {
        this.$notify({
          message: '绑定成功',
          background: '#00848A'
        });
        setTimeout(() => {
          this.$router.push('/patient');
        }, 1000);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Entering/firstMedicalRecord.vue